import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PricingPage from './pages/PricingPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function TitleUpdater() {
  const { currentLang, titles, pricingTitles } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/pricing') {
      document.title = pricingTitles[currentLang] || pricingTitles['es'];
    } else {
      document.title = titles[currentLang] || titles['es'];
    }
  }, [location, currentLang, titles, pricingTitles]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <ScrollToTop />
      <TitleUpdater />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pricing" element={<PricingPage />} />
      </Routes>
      <Footer />
    </LanguageProvider>
  );
}

export default App;
